<template>
  <template v-if="theme">
    <Padding :padding="theme.padding">
      <slot />
    </Padding>
  </template>
  <template v-else>
    <slot />
  </template>
</template>

<script setup lang="ts">
import Padding from '~/components/Atoms/Padding/Padding.vue';
import type { MediaTwoColumnTheme } from '~/sanity/types';

defineProps<{ theme?: MediaTwoColumnTheme }>();
</script>

<style lang="scss" scoped></style>
